<template>
    <div class="pin-settings" @click="$emit('close')">
        <div class="pin-settings-container" @click.stop>
            <div 
                class="pin-settings-item red"
                :class="{red: variable.warning}" 
                v-for="(variable, index) in variables"
                :key="index"
                @click="$emit('choise', variable)"
            >
                <p>{{ variable.title }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PinSettings',
    props: {
        variables: {
            type: Array,
            required: true
        }
    }
}
</script>
<style lang="stylus" scoped>
    .pin-settings
        position fixed
        left 0
        top 0
        right 0
        bottom 0
        display flex
        align-items center
        justify-content center
        z-index 5
        padding 20px

        &-container
            width 450px
            background-color white
            border-radius 20px
            box-shadow 0px 0px 30px rgba(162, 162, 162, 0.25)
            &.choise
                padding 40px
        
        &__title
            text-align center
            font-size 22px
            font-weight 500
            line-height 28px

        &-buttons
            display flex
            justify-content center
            margin-top 20px
            .button
                margin 0 15px

        &-item
            display flex
            justify-content center
            padding 15px 0
            font-size 16px
            font-weight 500
            border-bottom 1px solid #f0f0f0
            cursor pointer
            &:last-child
                border-bottom 0
            &.red
                color red
</style>